export default __webpack_public_path__ + "static/media/chet_faker_2.9869b5f4.jpg";